import React from "react";
import "../Footer.scss";
import logo1 from "../../images/logo1.svg";
import logo2 from "../../images/logo2.svg";
import logo3 from "../../images/logo3.svg";
import logo4 from "../../images/logo4.svg";
const Footer = () => {
  return (
    <div className="footerPage">
      <div className="FooterContainer">
        <div className="column1">
          <img className="logoIMG" src={logo1} alt="logo" />
          <div className="logos">
            <img className="logoIMG" src={logo2} alt="logo" />
            <img className="logoIMG" src={logo3} alt="logo" />
            <img className="logoIMG" src={logo4} alt="logo" />
          </div>
        </div>
        <div className="row2">
          <div className="rightColumn">
            <p className="footerText">About us</p>
            <p className="footerText">Blog</p>
          </div>
          <div className="rightColumn">
            <p className="footerText">Legal</p>
            <p className="footerText">Privacy Policy</p>
            <p className="footerText">Terms and conditions</p>
          </div>
          <div className="rightColumn">
            <p className="footerText">Help</p>
            <p className="footerText">Contact us</p>
          </div>
        </div>
      </div>
      <p className="footerParagraph" >
        S SRL - VAT BE0729.842.450 - contact@s.io - Avenue Armand Huysmans
        157,1050 Bruxelies
      </p>
    </div>
  );
};

export default Footer;
